import { createStyles } from "antd-style";
import { useBreakpoint } from "@/base/utils/index";

const useStyles = createStyles(({ token, css }: any) => ({
  root: css`
    background: ${token.ColorFigmaNeutralGrayscaleGray10};
    min-height: 100vh;
    position: fixed;
    inset: 0;
    z-index: 100;
    display: flex;
    flex-direction: column;
    justify-content: center;
  `,
}));

export const usePageError500Styles = () => {
  const screens = useBreakpoint();
  const styles = useStyles(screens);

  return styles;
};
